module.exports = __webpack_public_path__ + "static/media/letter-2.3514139c.png";